const NAMESPACE = "incentiveDesignList";

const KEYS = {
    incentiveDesignsTabLabel: "incentiveDesignsTabLabel",
    incentiveApprovalStatusTabLabel: "incentiveApprovalStatusTabLabel",
    incentiveOptionsTabLabel: "incentiveOptionsTabLabel",
    designDeleteDialogTitle: "designDeleteDialogTitle",
    designDeleteConfirmText: "designDeleteConfirmText",
    enableDesignInProgressText: "enableDesignInProgressText",
    disableDesignInProgressText: "disableDesignInProgressText",
    copyDesignInProgressText: "copyDesignInProgressText",
    deleteDesignInProgressText: "deleteDesignInProgressText",
    changeApprovalStatusDialogTitle: "changeApprovalStatusDialogTitle",
    removeApprovalStatusDialogTitle: "removeApprovalStatusDialogTitle",
    changeApprovalStatusDialogMsg: "changeApprovalStatusDialogMsg",
    removeApprovalStatusDialogMsg: "removeApprovalStatusDialogMsg",
    updateApprovalStatusInProgressText: "updateApprovalStatusInProgressText",
    setExpirationDateDialogTitle: "setExpirationDateDialogTitle",
    setExpirationDateCancelButtonText: "setExpirationDateCancelButtonText",
    setExpirationDateSaveButtonText: "setExpirationDateSaveButtonText",
    metadataEditDialogTitle: "metadataEditDialogTitle",
    metadataAddDialogTitle: "metadataAddDialogTitle",
    metadataEditDialogCancelButtonText: "metadataEditDialogCancelButtonText",
    metadataEditDialogSaveButtonText: "metadataEditDialogSaveButtonText",
    metadataEditInProgressText: "metadataEditInProgressText",
    metadataDeleteDialogTitle: "metadataDeleteDialogTitle",
    metadataDeleteConfirmText: "metadataDeleteConfirmText",
    metadataDeleteInProgressText: "metadataDeleteInProgressText"
};

const MESSAGES = {
    [KEYS.incentiveDesignsTabLabel]: {
        value: "Incentive Designs",
        comment: "Label for the Incentive Designs tab on the Incentive Designs page"
    },
    [KEYS.incentiveApprovalStatusTabLabel]: {
        value: "Approval Status",
        comment: "Label for the Approval Status tab on the Incentive Designs page"
    },
    [KEYS.incentiveOptionsTabLabel]: {
        value: "Options",
        comment: "Label for the Options tab on the Incentive Designs page"
    },
    [KEYS.designDeleteDialogTitle]: {
        value: "Delete Incentive Design",
        comment: "Title for dialog used to confirm deleting an incentive design"
    },
    [KEYS.designDeleteConfirmText]: {
        value: "Are you sure you want to delete the selected incentive design? This action cannot be undone.",
        comment: "Main text for dialog used to confirm deleting an incentive design"
    },
    [KEYS.enableDesignInProgressText]: {
        value: "Enabling incentive design...",
        comment: "Text to display when enabling an incentive design is in progress"
    },
    [KEYS.disableDesignInProgressText]: {
        value: "Disabling incentive design...",
        comment: "Text to display when disabling an incentive design is in progress"
    },
    [KEYS.copyDesignInProgressText]: {
        value: "Copying incentive design...",
        comment: "Text to display when copying an incentive design is in progress"
    },
    [KEYS.deleteDesignInProgressText]: {
        value: "Deleting incentive design...",
        comment: "Text to display when deleting an incentive design is in progress"
    },
    [KEYS.changeApprovalStatusDialogTitle]: {
        value: "Set Approval Status",
        comment: "Title of dialog used to confirm setting the Incentive Approval Status"
    },
    [KEYS.removeApprovalStatusDialogTitle]: {
        value: "Remove Approval Status",
        comment: "Title of dialog used to confirm the removal of the Incentive Approval Status"
    },
    [KEYS.changeApprovalStatusDialogMsg]: {
        value:
            "Are you sure you wish to make the selected status the Incentive Approval Status?" +
            " This will take effect immediately for any incentive designs that have been configured" +
            " to be limited to the Approved Incentive Amount.",
        comment: "Text in dialog used to confirm setting the Incentive Approval Status"
    },
    [KEYS.removeApprovalStatusDialogMsg]: {
        value:
            "Are you sure you wish to remove the Incentive Approval Status?" +
            " This will take effect immediately for any incentive designs that have been configured" +
            " to be limited to the Approved Incentive Amount.",
        comment: "Text in dialog used to confirm the removal of the Incentive Approval Status"
    },
    [KEYS.updateApprovalStatusInProgressText]: {
        value: "Updating Approval Status...",
        comment: "Text to display when updating the Incentive Approval Status is in progress"
    },
    [KEYS.setExpirationDateDialogTitle]: {
        value: "Set Expiration Date",
        comment: "Title for the Set Expiration Date dialog"
    },
    [KEYS.setExpirationDateCancelButtonText]: {
        value: "Cancel",
        comment: "Label for the Cancel button in the Set Expiration Date Dialog"
    },
    [KEYS.setExpirationDateSaveButtonText]: {
        value: "Save",
        comment: "Label for the Save button in the Set Expiration Date Dialog"
    },
    [KEYS.metadataEditDialogTitle]: {
        value: "Edit Metadata Field",
        comment: "Title of dialog used to edit an incentive metadata field"
    },
    [KEYS.metadataAddDialogTitle]: {
        value: "Add New Metadata Field",
        comment: "Title of dialog used to add a new incentive metadata field"
    },
    [KEYS.metadataEditDialogCancelButtonText]: {
        value: "Cancel",
        comment: "Text on button used to cancel adding or renaming an incentive metadata field"
    },
    [KEYS.metadataEditDialogSaveButtonText]: {
        value: "Save",
        comment: "Text on button used to save adding or renaming an incentive metadata field"
    },
    [KEYS.metadataEditInProgressText]: {
        value: "Saving incentive metadata field...",
        comment: "Text displayed when adding or renaming an incentive metadata field"
    },
    [KEYS.metadataDeleteDialogTitle]: {
        value: "Confirm: Delete Metadata Field",
        comment: "Title for dialog used to confirm deleting an incentive metadata field"
    },
    [KEYS.metadataDeleteConfirmText]: {
        value:
            "Are you sure you want to delete the selected incentive metadata field?" +
            " Project data for the corresponding incentive selector data fields will be retained in stand-alone data fields;" +
            " they will no longer be associated with an incentive selector data field group." +
            " The data values saved in this field for incentive designs will be discarded." +
            " This action cannot be undone.",
        comment: "Main text for dialog used to confirm deleting an incentive metadata field"
    },
    [KEYS.metadataDeleteInProgressText]: {
        value: "Deleting metadata field...",
        comment: "Text to display when deleting an incentive metadata field is in progress"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
